import New from "../clients/Newpf";
import EditC from "../clients/Edit";

//Todo de Newpdf -----------------------------------------------------------------------------------------------------
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React, { useState } from "react";
import "../../styles/newpf.css";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { UsuarioContext } from "../context/UsuarioContext";
import { useUsuarioStore } from "../zustandShared/usuarioStore";
import "react-datepicker/dist/react-datepicker.css";

const Modal_Clientes = (props) => {
  //Se obtiene el prop de que si es adquiriente u otorgante
  const { isAdquiriente } = props;
  //Para abrir el componente de Nueva persona fisica u moral
  const [abrirNuevo, setAbrirNuevo] = useState(false);
  //Para abrir el componente de edicion de persona fisica u moral
  const [abrirBuscar, setAbrirBuscar] = useState(false);
  //Para cerrar el modal
  const { cerrarModal, setCerrarModal } = useUsuarioStore();
  //Cambiar boton, en el edit y en el nuevo usuario, se pasa como prop
  const [buttonCerrar, setButtonCerrar] = useState(false);
  // --------------------------------------------------------------------------------------------------------------

  //Elegir el componente que se va a abrir, ya sea el de nueva persona o edicion de persona

  const nuevo = () => {
    //console.log("nuevo ejecutado")
    setButtonCerrar(true);
    setAbrirNuevo(true);
  };

  const buscar = () => {
    setButtonCerrar(true);
    setAbrirBuscar(true);
  };
  // -------------------------------------------------------------------------------------------------------------

  return (
    <div>
      <div style={{ position: "absolute", left: "-9999px" }}></div>

      {abrirNuevo || abrirBuscar ? (
        <>
          {abrirNuevo ? (
            <>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    width: "1000px",
                    height: "auto",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    maxWidth: "90%",
                  }}
                >
                  <div
                    style={{
                      maxHeight: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <UsuarioContext.Provider
                      value={{ abrirNuevo, setAbrirNuevo }}
                    >
                      <New />
                    </UsuarioContext.Provider>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    width: "1000px",
                    height: "auto",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    maxWidth: "90%",
                  }}
                >
                  <div
                    style={{
                      maxHeight: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <UsuarioContext.Provider
                      value={{ abrirBuscar, setAbrirBuscar }}
                    >
                      <EditC />
                    </UsuarioContext.Provider>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
           
          {cerrarModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "650px",
                  height: "300px",
                  maxWidth: "90%",
                }}
              >
                {isAdquiriente ? (
                  <>
                    <h3>Adquirientes</h3>
                    <hr />
                    <div
                      style={{ position: "absolute", top: "40%", left: "37%" }}
                    >
                      <MDBRow>
                        <MDBCol>
                          <button
                            onClick={buscar}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              fontSize: "20px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              marginTop: "25px",
                            }}
                          >
                            <i className="fas fa-users"></i>
                            <span style={{ marginLeft: "15px" }}>
                              Buscar entre los clientes del catálogo
                            </span>
                          </button>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow>
                        <MDBCol>
                          <button
                            onClick={nuevo}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              fontSize: "20px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              marginTop: "25px",
                            }}
                          >
                            <div style={{ height: "25px" }}></div>

                            <i className="fas fa-user-plus"></i>

                            <span style={{ marginLeft: "15px" }}>
                              Capturar un cliente nuevo
                            </span>
                          </button>
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </>
                ) : (
                  <>
                    <h3>Otorgantes</h3>
                    <hr />
                    <div
                      style={{ position: "absolute", top: "40%", left: "37%" }}
                    >
                      <MDBRow>
                        <MDBCol>
                          <button
                            onClick={buscar}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              fontSize: "20px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              marginTop: "25px",
                            }}
                          >
                            <i className="fas fa-users"></i>
                            <span style={{ marginLeft: "15px" }}>
                              Buscar entre los clientes del catálogo
                            </span>
                          </button>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow>
                        <MDBCol>
                          <button
                            onClick={nuevo}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              fontSize: "20px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              marginTop: "25px",
                            }}
                          >
                            <div style={{ height: "25px" }}></div>

                            <i className="fas fa-user-plus"></i>

                            <span style={{ marginLeft: "15px" }}>
                              Capturar un cliente nuevo
                            </span>
                          </button>
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </>
                )}

                <button
                  className="btn btn-primary position"
                  style={{ position: "absolute", top: "62%", right: "30%" }}
                  onClick={() => setCerrarModal(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Modal_Clientes;
